import './Skeleton.css';

export const BarberSkeleton = () => (
    <div className="barber-skeleton-card">
        <div className="skeleton-image"></div>
        <div className="skeleton-info">
            <div className="skeleton-line title"></div>
            <div className="skeleton-line button"></div>
        </div>
    </div>
);

export const ServiceSkeleton = () => (
    <div className="service-skeleton-item">
        <div className="skeleton-info">
            <div className="skeleton-line title"></div>
            <div className="skeleton-line subtitle"></div>
        </div>
        <div className="skeleton-price"></div>
    </div>
);
